/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function BlockImage({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M5.75 1.4a2.85 2.85 0 1 0 0 5.7 2.85 2.85 0 0 0 0-5.7M4.1 4.25a1.65 1.65 0 1 1 3.3 0 1.65 1.65 0 0 1-3.3 0M8.281 7.98c1.014-1.66 3.424-1.66 4.438 0l2.863 4.686c.652 1.066-.116 2.434-1.365 2.434H2c-1.318 0-2.071-1.505-1.28-2.56l1.7-2.267a2.6 2.6 0 0 1 4.16 0l.165.22zm-2.21 3.616L4.665 13.9H2a.4.4 0 0 1-.32-.64l1.7-2.267a1.4 1.4 0 0 1 2.24 0zm5.624-2.99a1.4 1.4 0 0 0-2.39 0L6.07 13.9h8.147a.4.4 0 0 0 .341-.609z" clipRule="evenodd" /></svg>;
}
;